import './Experience.css';

export default function Experience() {
  return (
    <section id="experience">
      <div className="container">

        <div className="exp-heading">
          <p className="section-label">Impact</p>
          <h2 className="section-title" style={{ marginBottom: 0 }}>What I've Built</h2>
        </div>

        <div className="bento">

          {/* ── row 1: stat cards ── */}
          <div className="b-card b-stat-1">
            <div className="b-stat-value">5+</div>
            <div className="b-stat-label">Years shipping production software</div>
          </div>

          <div className="b-card b-stat-2">
            <div className="b-stat-value">15+</div>
            <div className="b-stat-label">Microservices owned & maintained</div>
          </div>

          <div className="b-card b-stat-3">
            <div className="b-stat-value">3×</div>
            <div className="b-stat-label">Tech conference talks delivered</div>
          </div>

          <div className="b-card b-stat-4">
            <div className="b-stat-value">17%</div>
            <div className="b-stat-label">Query performance improvement</div>
          </div>

          {/* ── row 2-3: company + hackathon ── */}
          <div className="b-card b-company-1">
            <div className="b-company-badge">Current · 2025 – Present</div>
            <div className="b-company-name">Foundation Finance LLC</div>
            <div className="b-company-role">Senior Full-Stack Developer</div>
            <div className="b-company-win">
              Owns end-to-end <strong>IAM infrastructure</strong>, distributed Kafka microservices,
              and GraphQL/REST pricing APIs across a multi-database architecture.
            </div>
            <div className="b-tags">
              {['NestJS', 'Kafka', 'AWS Cognito', 'GraphQL', 'New Relic'].map(t => (
                <span key={t} className="b-tag">{t}</span>
              ))}
            </div>
          </div>

          <div className="b-card b-company-2">
            <div className="b-company-name">MANiT Labs</div>
            <div className="b-company-role">Full-Stack Developer · 2022 – 2025</div>
            <div className="b-company-win">
              Built a full-stack <strong>Gmail integration</strong> from scratch and a
              React/TypeScript component library with Storybook documentation.
            </div>
            <div className="b-tags">
              {['React', 'FastAPI', 'TypeScript', 'Docker', 'Storybook'].map(t => (
                <span key={t} className="b-tag">{t}</span>
              ))}
            </div>
          </div>

          <div className="b-card b-win">
            <div className="b-win-emoji">🏆</div>
            <div className="b-win-title">2026 Hackathon Winner</div>
            <div className="b-win-desc">
              Architected & shipped a production-ready AI dealer support chatbot
              in 8 hours — Amazon Bedrock, RAG retrieval, NestJS backend.
            </div>
          </div>

          {/* ── row 4-5: early career ── */}
          <div className="b-card b-company-3">
            <div className="b-company-name">Esther.ai & BOE Partners</div>
            <div className="b-company-role">Full-Stack Developer · 2021 – 2022</div>
            <div className="b-company-win">
              Built real-time data visualizations on an <strong>AI-native platform</strong> and
              a full-stack school directory with auth, Mailchimp integration, and a
              Node/MongoDB REST API.
            </div>
            <div className="b-tags">
              {['Next.js', 'React', 'Node.js', 'MongoDB', 'Python'].map(t => (
                <span key={t} className="b-tag">{t}</span>
              ))}
            </div>
          </div>

          {/* ── row 6: speaking cards + scholarship ── */}
          <div className="b-card b-talk b-talk-1">
            <a href="https://www.meetup.com/floridajs/events/301597705/" target="_blank" rel="noopener noreferrer" className="b-talk-link">
              <div className="b-talk-top">
                <span className="b-talk-badge">Speaker</span>
                <span className="b-talk-arrow">↗</span>
              </div>
              <div className="b-talk-name">FloridaJS</div>
              <div className="b-talk-date">August 2024</div>
            </a>
          </div>

          <div className="b-card b-talk b-talk-2">
            <a href="https://www.meetup.com/swfl-coders/events/301626975/" target="_blank" rel="noopener noreferrer" className="b-talk-link">
              <div className="b-talk-top">
                <span className="b-talk-badge">Speaker</span>
                <span className="b-talk-arrow">↗</span>
              </div>
              <div className="b-talk-name">SWFL Coders</div>
              <div className="b-talk-date">July 2024</div>
            </a>
          </div>

          <div className="b-card b-talk b-talk-3">
            <a href="https://www.linkedin.com/posts/camilasandovals_ai-techworkshop-southfloridatech-activity-7189627357001871362-0TYZ/" target="_blank" rel="noopener noreferrer" className="b-talk-link">
              <div className="b-talk-top">
                <span className="b-talk-badge">Speaker</span>
                <span className="b-talk-arrow">↗</span>
              </div>
              <div className="b-talk-name">South Florida DevCon</div>
              <div className="b-talk-date">May 2024</div>
            </a>
          </div>

          <div className="b-card b-scholarship">
            <a href="https://techhubsouthflorida.org/techstrong-grants-scholarship-diversity-in-tech/" target="_blank" rel="noopener noreferrer" className="b-talk-link">
              <div className="b-talk-top">
                <span className="b-talk-badge b-badge-gold">Scholarship</span>
                <span className="b-talk-arrow">↗</span>
              </div>
              <div className="b-talk-name">Engineer the Change</div>
              <div className="b-talk-date">TechHub South Florida · 2023</div>
              <div className="b-scholarship-sub">Diversity in Tech recipient</div>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
